import "./DotRingComponentTest.scss"

import { useEffect, useState } from "react";

function DotRingComponent() {

  const [ deviceType, setDeviceType ] = useState()

  const mouseMoveHandler = (e) => {
    const Ring = document.querySelector(".ring")
    const Dot = document.querySelector(".dot")

    if (!Ring || !Dot) {
      console.log("Refresh page in Desktop mode to view Ring and Dot")
      return
    }

    const { clientX, clientY } = e
      // document.querySelector(".ring").animate({
        Ring.animate({
        left: `${clientX}px`,
        top: `${clientY}px`,
      }, {duration: 3000, fill: 'forwards'})
      // document.querySelector(".dot").animate({
        Dot.animate({
        left: `${clientX}px`,
        top: `${clientY}px`,
      }, {duration: 1000, fill: 'forwards'})
  }

  useEffect(() => {
    let hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
      hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ("msMaxTouchPoints" in navigator) {
      hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
      const mQ = window.matchMedia && matchMedia("(pointer:coarse)");
      if (mQ && mQ.media === "(pointer:coarse)") {
        hasTouchScreen = !!mQ.matches;
      } else if ("orientation" in window) {
        hasTouchScreen = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        var UA = navigator.userAgent;
        hasTouchScreen =
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
      }
    }
    if (hasTouchScreen) {
      setDeviceType("Mobile");
    } else {
      setDeviceType("Desktop");
      document.addEventListener('mousemove', mouseMoveHandler)
    }
    
    // Listen to mouse movement
    // document.addEventListener('mousemove', mouseMoveHandler)

    // Remove the listener when component unloads
    return () => {
      document.removeEventListener('mousemove', mouseMoveHandler)
    }
  },[])

  return (
    <>
      {deviceType === "Desktop" && 
      <>
        <div className="ring"></div>
        <div className="dot"></div>
      </>}
    </>
  )
}

export default DotRingComponent